import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import * as utils from './Utils';


export function formatCartItem(itemRow) {
  let item = {};
  item['id'] = `${itemRow.id}`;
  item['title'] = itemRow.title;
  item['quantity'] = itemRow.quantity;
  item['price'] = utils.convertCentsToFloat(itemRow.price);
  item['product_id'] = `${itemRow.product_id}`;
  item['product_title'] = itemRow.product_title;
  item['variant_id'] = `${itemRow.variant_id}`;
  item['variant_title'] = itemRow.variant_title;
  item['image_url'] = itemRow.image || itemRow.featured_image && itemRow.featured_image.url || '';
  return item;
}

export function formatCartResponse(response) {
  let data = {};
  data['currency'] = response.currency;
  data['total_price'] = utils.convertCentsToFloat(response.total_price);
  data['original_total_price'] = utils.convertCentsToFloat(response.original_total_price);
  data['items_subtotal_price'] = utils.convertCentsToFloat(response.items_subtotal_price);

  let totalDiscount = parseFloat(0);
  if (response.cart_level_discount_applications) {
    response.cart_level_discount_applications.forEach((row) => {
      totalDiscount += utils.convertCentsToFloat(row.total_allocated_amount)
    })
  }

  data['total_discount'] = totalDiscount;

  let items = [];
  response.items.forEach((itemRow) => {
    let item = formatCartItem(itemRow);
    items.push(item);
  })

  data['items'] = items;
  return data;
}


function getAddedCartItems(response) {
  const existingData = get(window.OnVoardEventsData, 'shopify_cart', {});
  const existingMapper = {};
  if (existingData.items) {
    existingData.items.forEach((itemRow) => {
      existingMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })
  }

  const currentMapper = {};
  if (response.items) {
    response.items.forEach((itemRow) => {
      currentMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })
  }

  let addedIds = utils.getAddedCartItemIds(existingMapper, currentMapper);
  let addedItems = [];
  if (response.items) {
    response.items.forEach((itemRow) => {
      let itemId = `${itemRow.id}`;
      if (!addedIds.includes(itemId)) return;
      addedItems.push(itemRow)
    })
  }

  return addedItems;
}

export function handleCartUpdate(response) {
  let noChange = isEqual(window.OnVoardEventsData['shopify_cart'], response);
  let isNew = !window.OnVoardEventsData['shopify_cart'] ? true : false;

  // no cart change
  if (noChange) return;

  // if first time loading, don't dispatch added cart items
  let addedCartItems = [];
  if (!isNew) addedCartItems = getAddedCartItems(response);

  window.OnVoardEventsData['shopify_cart'] = response;
  utils.dispatchCartUpdateEvent(response);
  addedCartItems.forEach((item) => {
    utils.dispatchAddCartItemEvent(item);
  })
}

export function setupCartUpdateEvent() {
  if (window.OnVoardEventsData.setupCartUpdateEvent) return;
  window.OnVoardEventsData.setupCartUpdateEvent = true;

  let cartUpdatePaths = [
    "/cart.js",
    "/cart/update.js",
    "/cart/update",
    "/cart/change.js",
    "/cart/change",
    "/cart/clear.js",
    "/cart/clear",
  ];

  utils.interceptRequests(cartUpdatePaths, (response, url) => {
    response = utils.parseResponse(response);
    if (!response) return;
    handleCartUpdate(response);
  });

  let shopifytriggerPaths = [
    "/cart/add.js",
    "/cart/add",
  ];

  let triggerCartUpdate = () => {
    utils.getRq({
      "url": "/cart.js",
      "headers": {
        "x-requested-with": "XMLHttpRequest",
      },
      "successCallback": (response) => {
        response = utils.parseResponse(response);
        if (!response) return;
        handleCartUpdate(response);
      },
      "errorCallback": () => {}
    });
  };

  utils.interceptRequests(shopifytriggerPaths, (response, url) => {
    triggerCartUpdate();
  });
}


export function loadCart() {
  let successCallback = (response) => {
    response = utils.parseResponse(response);
    if (!response) return;
    handleCartUpdate(response);
  };

  let errorCallback = () => {};

  utils.getRq({
    "url": "/cart.js",
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function addToCart(variantId, kwargs={}) {
  // Shopify's storefront cart add keys on the variant id (not the product id).
  // Free-product rewards target single-variant products, so the backend
  // resolves and supplies that single variant id.
  const quantity = kwargs.quantity || 1;
  const couponCode = kwargs.couponCode || null;
  const successCallback = kwargs.successCallback || (() => {});
  const errorCallback = kwargs.errorCallback || (() => {});

  utils.postRq({
    "url": "/cart/add.js",
    "data": JSON.stringify({ "id": parseInt(variantId), "quantity": quantity }),
    "headers": {
      "Content-Type": "application/json",
      "x-requested-with": "XMLHttpRequest",
    },
    "successCallback": (response) => {
      // Shopify can't apply a discount via the AJAX cart API, so once the item
      // is added we send the customer through the discount URL. Visiting it
      // applies the code and (via redirect) lands them on the cart with it
      // active — so add-item + apply-coupon happen in one action.
      if (couponCode) {
        window.location.href = `/discount/${encodeURIComponent(couponCode)}?redirect=/cart`;
        return;
      }
      successCallback(response);
    },
    "errorCallback": errorCallback,
  });
}

